import { Seo } from "@/components/layout/Seo";
import { HomeHero } from "@/components/home/HomeHero";
import { Intro } from "@/components/home/Intro";
import { Ecosystem } from "@/components/home/Ecosystem";
import { WhyVion, WhoWeServe } from "@/components/home/Principles";
import { Marquee } from "@/components/motion/Marquee";
import { CtaBand } from "@/components/sections/CtaBand";

export default function Home() {
  return (
    <>
      <Seo
        title="VION Tech | AI, Technology, Education & Global Opportunities"
        description="VION Tech helps individuals, businesses and institutions learn, adopt and benefit from AI and emerging technologies while connecting people to education, career and global opportunities."
        path="/"
      />
      <HomeHero />
      <Marquee />
      <Intro />
      <Ecosystem />
      <WhyVion />
      <WhoWeServe />
      <CtaBand
        testid="home-partnership-cta"
        text="We are open to strategic partnerships with businesses, educational institutions, technology companies, government and development organisations, investors, sponsors and international partners."
        primary={{ label: "Partner With VION Tech", to: "/partnerships" }}
        secondary={{ label: "Get Started", to: "/contact" }}
      />
    </>
  );
}
